module.exports = __webpack_public_path__ + "assets/6343be78b579595fee44585a05f1cb01.png";